export default "__VITE_ASSET__BNSX3aqI__"